
<router-outlet></router-outlet>
<cricteams-app-switcher></cricteams-app-switcher>
<cricteams-alert-banner [isError]="isError" [isSuccess]="isSuccess" [message]="message" />
